import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./App.css";

import Home from "./components/Home/Home";
import Streetfood from "./components/Streetfood/Streetfood";
import Dhaba from "./components/Dhaba/Dhaba";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import Blog from "./components/Blog/Blog";
import AboutUs from "./components/AboutUs/AboutUs";
function App() {
  return (
    <BrowserRouter>
      <Header />
      <div className="App">
        <Routes>
          <Route path="/" element={<Home />} />

          <Route path="/streetfood" element={<Streetfood />} />

          <Route path="/dhaba" element={<Dhaba />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/about" element={<AboutUs/>}/>
          <Route path="/https://zikrme.com/privacy-policy/" />
          
        </Routes>
      </div>
      <Footer/>
    </BrowserRouter>
  );
}

export default App;
